export default "__VITE_PUBLIC_ASSET__5f3335fa__"